import script from "./CheckboxGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckboxGroup.vue?vue&type=script&setup=true&lang=js"

import "./CheckboxGroup.vue?vue&type=style&index=0&id=0926414e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0926414e"]])

export default __exports__